<script lang="ts" setup>
import arrowOutwardWhite from "@/assets/image/icons/arrow-outward-white.svg";
import type { RouteName } from "@/router";

withDefaults(
  defineProps<{
    image: string;
    alt: string;
    text: string;
    routeName: RouteName;
    active?: boolean;
  }>(),
  {}
);
</script>

<template>
  <div class="relative h-full max-h-full w-full max-w-[calc(100vw-128px)] overflow-hidden rounded-lg md:max-w-[64vw]">
    <img :src="image" :alt="alt" class="min-h-full object-cover object-center" loading="lazy" />
    <div
      class="bg-overlay-primary/80 absolute inset-0 flex flex-col justify-between p-8 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
      :class="{ 'opacity-100': active }"
    >
      <!-- Placeholder for the icon -->
      <div
        class="border-text-light flex h-[42px] min-h-[42px] w-[42px] min-w-[42px] cursor-pointer items-center justify-center self-end rounded-full border-[3px] hover:opacity-80 md:h-[56px] md:min-h-[56px] md:w-[56px] md:min-w-[56px]"
      >
        <router-link :to="{ name: routeName }">
          <div class="flex h-8 w-8 items-center justify-center">
            <img :src="arrowOutwardWhite" alt="arrow outward" /></div
        ></router-link>
      </div>
      <div class="leading-[150%] md:text-xl">{{ text }}</div>
    </div>
  </div>
</template>
